import { Backdrop, Box, Container, Grid } from '@mui/material';
import AdvisorProfileSummaryCard from './AdvisorProfileSummaryCard';
import LikeButton from './LikeButton';
import ShareButton from './ShareButton';
import styles from './AdvisorProfile.module.css';

import {
  useDownXl,
  useEqual,
  useIsTablet,
  useIsPortraitTablet,
} from 'hooks/useBreakpoints/useBreakpoints';
import AdvisorProfileCardSlides from './AdvisorProfileCardSlides';
import { Advisor } from 'types';
import {
  AdvisorProfileThemeProvider,
  useAdvisorProfileTheme,
} from './AdvisorProfileThemeProvider';
import VSpace from '../VSpace';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
import AdvisorProfileNav from './AdvisorProfileNav';
// import AdvisorProfileNavModal from './AdvisorProfileNavModal';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useAdviserProfileOwner } from 'hooks/useAdviserProfileOwner';
import { PaidFeatureAlertType } from '../PaidFeatureAlert/PaidFeatureAlert.types';
// import Backbutton from '../Backbutton/Backbutton';
import { AuthenticatedUserContext, trackMilestoneEvent } from 'hooks/hooks';
import AdvisorProfilePlusBottom from './AdvisorProfilePlusBottom';
import HSpace from '../HSpace';
import Loading from '../Loading/Loading';
import AdviserActionFAB from '../AdviserActionFAB/AdviserActionFAB';
// import LanguageButton from '../LanguageButton';
import clsx from 'clsx';
import AdviserProfileTopNav from '../AdviserProfileTopNav/AdviserProfileTopNav';
import { isNativeApp } from 'utils/DeviceInfo/deviceOS';
import { api } from 'services/api';
import { useSearchParams } from 'react-router-dom';
import FocusingAdviserProfileProvider from 'hooks/useFocusingAdviserProfile/useFocusingAdviserProfile';
import Backbutton from '../Backbutton/Backbutton';

export function AdvisorProfilePageContent({
  advisor,
  onShowShortcut,
  isDemo,
  isFreeUser,
  paidFeatureAlertType,
}: {
  advisor: Advisor;
  onShowShortcut?: () => void;
  isDemo: boolean;
  isFreeUser: boolean;
  paidFeatureAlertType: PaidFeatureAlertType;
}) {
  const { buttonSx, mainColor } = useAdvisorProfileTheme();
  const isTablet = useIsTablet();
  const isLG = useEqual('lg');
  const AuthenticatedUser = useContext(AuthenticatedUserContext);
  const isAdvisorProfileOwnedByUser = AuthenticatedUser.isAdviserProfileOwner(
    advisor.userId,
  );

  // const topHDiff = useHeightDifference(670);
  // const paginationPosition = topHDiff >= 0 ? 12 : 0;
  const isPortraitTablet = useIsPortraitTablet();
  const isNative = isNativeApp();
  const AdvisorProfileCardSlidesRef = useRef<any>(null);

  useEffect(() => {
    if (AdvisorProfileCardSlidesRef.current?.swiper) {
      console.log(
        'swiper found:: ',
        AdvisorProfileCardSlidesRef.current.swiper,
      );
      AdvisorProfileCardSlidesRef.current?.swiper?.slideNext();
      setTimeout(() => {
        console.log(' swiper autoplay start, slidePrev ');
        AdvisorProfileCardSlidesRef.current?.swiper?.slidePrev();
        AdvisorProfileCardSlidesRef.current?.swiper?.autoplay?.start();
      }, 500);
    }
  }, [AdvisorProfileCardSlidesRef]);
  return useMemo(() => {
    function getSwiperPagination() {
      const content = (
        <Box
          className={clsx(styles.swiperPagination, 'swiper-pagination')}
          sx={{ justifyContent: 'center', alignItems: 'center' }}
        />
      );

      return content;
    }

    if (AuthenticatedUser.isAnyPartLoading) {
      return <Loading />;
    } else if (isTablet) {
      return (
        <div className={styles.layout}>
          {/* {!isPortraitTablet && paginationPosition <= 0 && <VSpace size={3} />}
          {isAdvisorProfileOwnedByUser && <VSpace size={6} />}
          {isPortraitTablet && <VSpace size={5} />} */}
          <Backbutton cardId={advisor.userId} />
          <AdviserProfileTopNav cardId={advisor.userId} />

          <Box
            sx={{
              // margin: 'auto',
              alignContent: 'center',
              // display: 'flex',
              // flexDirection: 'column',
              justifyContent: 'center',
              flexGrow: 1,
              height: 'content-fit',
              paddingBottom: isNative ? '64px' : '48px',
            }}
          >
            {isPortraitTablet && getSwiperPagination()}

            <AdvisorProfileCardSlides
              cardSx={{
                width: '100%',
                // height: !isPortraitTablet ? '100%' : 'calc(100% - 24px)',
              }}
              isDemo={!!isDemo}
              advisor={advisor}
              onShowShortcut={onShowShortcut}
              isFreeUser={isFreeUser}
              paidFeatureAlertType={paidFeatureAlertType}
              ref={AdvisorProfileCardSlidesRef}
            ></AdvisorProfileCardSlides>
          </Box>
          <Box
            className={clsx(
              isAdvisorProfileOwnedByUser
                ? styles?.['fab-relative']
                : styles.fab,
            )}
            sx={{
              width: isPortraitTablet ? 'calc(100% - 48px)' : '100%',
              bottom: isNative ? '36px' : '12px',
              ...(isAdvisorProfileOwnedByUser
                ? {
                    bottom: '28px',
                    padding: isPortraitTablet ? '24px 0px 0px 0px' : '0px 24px',
                  }
                : {}),
            }}
          >
            {isAdvisorProfileOwnedByUser ? (
              <AdvisorProfilePlusBottom
                likeCount={advisor.likes}
                advisor={advisor}
              />
            ) : (
              <Box className={styles.footer}>
                <LikeButton
                  shouldShowLikeForm={isDemo || !isFreeUser}
                  sx={{ ...buttonSx, width: 'calc(100vw - 120px)', height: '39px' }}
                  advisor={advisor}
                />
                <ShareButton
                  sx={{ ...buttonSx, width: '39px', height: '39px' }}
                  advisor={advisor}
                />
              </Box>
            )}
          </Box>
        </div>
      );
    }

    // console.log('rendering default AdvisorProfilePageContent');

    return (
      <Grid container>
        {/* <Box
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            margin: '16px',
            zIndex: 100,
            justifyContent: 'space-between',
            display: 'flex',
            width: 'calc(100vw - 32px)',
          }}
        >
          <Backbutton isSelfCard={isAdvisorProfileOwnedByUser} />
          <LanguageButton color={mainColor} />
        </Box> */}
        <Backbutton cardId={advisor.userId} />

        <Grid item xs={12}>
          <AdviserProfileTopNav cardId={advisor.userId} />
        </Grid>

        <Grid
          item
          md={5}
          justifyContent="center"
          alignItems="flex-start"
          margin="auto"
        >
          <AdvisorProfileSummaryCard
            isDemo={isDemo}
            advisor={advisor}
            onShowShortcut={onShowShortcut}
            isFreeUser={isFreeUser}
            paidFeatureAlertType={paidFeatureAlertType}
            shakeOnWhatsapp={true}
          />
          {isAdvisorProfileOwnedByUser ? (
            isLG && (
              <Box
                sx={{
                  width: '90%',
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '16px',
                }}
              >
                <AdvisorProfilePlusBottom
                  likeCount={advisor.likes}
                  advisor={advisor}
                />
              </Box>
            )
          ) : (
            <Box className={styles['xl-footer']}>
              <VSpace size={4} />
              <Grid
                container
                gap={1}
                maxWidth={300}
                wrap="nowrap"
                margin="auto"
              >
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Grid container>
                    <Grid item flexGrow={1}>
                      <LikeButton
                        sx={{ ...buttonSx }}
                        advisor={advisor}
                        shouldShowLikeForm={isDemo || !isFreeUser}
                      />
                    </Grid>
                    <HSpace size={1} />
                    <Grid item>
                      <ShareButton
                        sx={{
                          ...buttonSx,
                          width: '39px',
                          height: '39px',
                          borderRadius: '50%',
                        }}
                        advisor={advisor}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Box>
          )}
        </Grid>
        <Grid item xs={7} md={7}>
          {!isTablet && getSwiperPagination()}
          <AdvisorProfileCardSlides
            isDemo={isDemo}
            advisor={advisor}
            onShowShortcut={onShowShortcut}
            isFreeUser={isFreeUser}
            paidFeatureAlertType={paidFeatureAlertType}
          />
        </Grid>
      </Grid>
    );
  }, [
    AuthenticatedUser.isAnyPartLoading,
    isTablet,
    advisor,
    isDemo,
    onShowShortcut,
    isFreeUser,
    paidFeatureAlertType,
    isAdvisorProfileOwnedByUser,
    isLG,
    buttonSx,
    isNative,
    isPortraitTablet,
  ]);
}

function WrappedAdvisorProfile({
  advisor,
  onShowShortcut,
  isDemo,
  isFreeUser,
  paidFeatureAlertType,
}: {
  advisor: Advisor;
  onShowShortcut?: () => void;
  isDemo: boolean;
  isFreeUser: boolean;
  paidFeatureAlertType: PaidFeatureAlertType;
}) {
  const isAdvisorProfileOwnedByUser = useAdviserProfileOwner(advisor);
  const isDownXl = useDownXl();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Backdrop open={open} sx={{ zIndex: 1000 }} />
      <Box className={styles.background}>
        <Box
          className={styles.container}
          sx={
            {
              // height: '100%',
              // 'calc(100% - 16px)'
            }
          }
        >
          {!isDownXl && isAdvisorProfileOwnedByUser && (
            <div className={styles.navContainer}>
              <AdvisorProfileNav advisor={advisor} elevation={3} />
            </div>
          )}
          <Container
            maxWidth="md"
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: 0,
            }}
          >
            <AdvisorProfilePageContent
              advisor={advisor}
              onShowShortcut={onShowShortcut}
              isDemo={isDemo}
              isFreeUser={isFreeUser}
              paidFeatureAlertType={paidFeatureAlertType}
            ></AdvisorProfilePageContent>
          </Container>
        </Box>
      </Box>
      {isDownXl && isAdvisorProfileOwnedByUser && (
        <Box
          sx={{
            position: 'fixed',
            right: 24,
            bottom: 24,
            zIndex: 1100,
          }}
        >
          <AdviserActionFAB
            plan={isFreeUser}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            advisor={advisor}
          />
        </Box>

        /* <Fab
            sx={{
              position: 'fixed',
              bottom: 16,
              right: 16,
              backgroundColor: mainColor,
              color: 'white',
              ':hover': {
                backgroundColor: color3,
              },
            }}
            onClick={() => {
              setIsNavModalOpen(true);
            }}
          >
            <MoreVertIcon />
          </Fab>
          <AdvisorProfileNavModal
            advisor={advisor}
            show={isNavModalOpen}
            onClose={() => {
              setIsNavModalOpen(false);
            }}
          /> */
      )}
    </>
  );
}

export const getMainColorFromThemeColor = (themeColor: string) => {
  const computedStyle = getComputedStyle(document.body);
  switch (themeColor) {
    case 'blue':
      return computedStyle.getPropertyValue('--biz-page-blue-1');
    case 'green':
      return computedStyle.getPropertyValue('--biz-page-green-1');
    case 'orange':
      return computedStyle.getPropertyValue('--biz-page-orange-1');
    case 'violet':
      return computedStyle.getPropertyValue('--biz-page-violet-1');
    case 'earth':
      return computedStyle.getPropertyValue('--biz-page-earth-1');
  }
};

export const getMainGridentBackground = (themeColor: string) => {
  const computedStyle = getComputedStyle(document.body);
  switch (themeColor) {
    case 'blue':
      return computedStyle.getPropertyValue('--biz-page-blue-background');
    case 'green':
      return computedStyle.getPropertyValue('--biz-page-green-background');
    case 'orange':
      return computedStyle.getPropertyValue('--biz-page-orange-background');
    case 'violet':
      return computedStyle.getPropertyValue('--biz-page-violet-background');
    case 'earth':
      return computedStyle.getPropertyValue('--biz-page-earth-background');
  }
};

export default function AdvisorProfilePage({
  advisor,
  onShowShortcut,
  isDemo = false,
  isFreeUser,
  paidFeatureAlertType,
}: {
  advisor: Advisor;
  onShowShortcut?: () => void;
  isDemo?: boolean;
  isFreeUser: boolean;
  paidFeatureAlertType: PaidFeatureAlertType;
}) {
  const AuthenticatedUser = useContext(AuthenticatedUserContext);

  const mainColor =
    advisor?.adviserInfo?.customThemeColor ||
    getMainColorFromThemeColor(advisor?.adviserInfo.themeColor || 'blue');

  // const advisorThemeColor = advisor?.adviserInfo.themeColor || 'blue';
  // const bg = getAdviserThemeValue(
  //   advisorThemeColor,
  //   AdviserThemeValueType.GridentBG,
  // );

  const [searchParams] = useSearchParams();
  const m = searchParams.get('m');
  const s = searchParams.get('s');

  const timerRef = useRef<NodeJS.Timeout | undefined>(undefined);
  const [trackDirectAnonymous] = api.useTrackDirectAnonymousMutation();

  useEffect(() => {
    if (AuthenticatedUser.isLoading.user) return;
    if (advisor === null) return;
    const targetAdvisorId = advisor.adviserInfo._id;
    if (targetAdvisorId === AuthenticatedUser.user?._id) return;

    const timer = setTimeout(() => {
      trackDirectAnonymous({
        target: targetAdvisorId,
        type: 'clientViewEcard',
        detail: m || s || 'link',
      });
      trackMilestoneEvent({
        type: 'Profile Viewed',
        event_properties: {
          medium: m || 'link',
          source: s ?? '',
          Success: true,
          'Focusing Advisor ID': targetAdvisorId,
        },
      });
    }, 5000);

    timerRef.current = timer;
    return () => {
      clearTimeout(timer);
    };
  }, [
    AuthenticatedUser.isLoading.user,
    AuthenticatedUser.user,
    advisor.adviserInfo._id,
    trackDirectAnonymous,
    m,
    s,
    advisor,
  ]);

  return (
    <FocusingAdviserProfileProvider advisor={advisor}>
      <AdvisorProfileThemeProvider mainColor={mainColor}>
        <WrappedAdvisorProfile
          advisor={advisor}
          onShowShortcut={onShowShortcut}
          isDemo={isDemo}
          isFreeUser={isFreeUser}
          paidFeatureAlertType={paidFeatureAlertType}
        />
      </AdvisorProfileThemeProvider>
    </FocusingAdviserProfileProvider>
  );
}
